export const VIDEO_TOUR_ICON = "https://media.cars24.com.au/cms/b2c/cms/2025/08/21/5f84da67-25e8-482b-a167-00327e99d1c4Group%201686553702%20%283%29%20%281%29.webp";
